import { jwtDecode } from "jwt-decode";
import apiClient from "../../../Config/apiClient";
import { retrieve, remove, store } from "../../../Services/localStorageService";
import { isUserActive, startUserActivityTracker } from "../../../Services/userActivity";

const signInUrl = process.env.REACT_APP_HS_SIGNIN_BASE_PATH;

export const getUserInfo = () => {
  const token = retrieve('accessToken');
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return {
      role: decoded.role,
      permissions: decoded.permissions,
    };
  } catch (err) {
    return null;
  }
};

export const isTokenValid = () => {
  const token = retrieve("accessToken");
  const expiry = retrieve("accessTokenExpiry");

  if (!token || !expiry) return false;

  try {
    const isNotExpired = Date.now() < Number(expiry);

    if (!isNotExpired) return false;
    const decoded = jwtDecode(token);
    return decoded?.module === "HS";
  } catch (error) {
    console.error("Error validating token:", error);
    return false;
  }
};

export const clearAuth = () => {
  ["accessToken", "accessTokenExpiry", "refreshToken", "refreshTokenExpiry"].forEach(remove);
}

export const logout = async () => {
  const refreshToken = retrieve("refreshToken");

  try {
    if (refreshToken) {
      await apiClient.post(`${signInUrl}/logout`, { refreshToken });
    }
  } catch (error) {
    console.warn("Logout API failed:", error?.response?.data || error.message);
  } finally {
    ["accessToken", "accessTokenExpiry", "refreshToken", "refreshTokenExpiry"].forEach(remove);
    store("showSignInModalHS", "true");
    window.location.href = "/";
  }
};

let monitorTimeout = null;

const RefreshToken = async (logoutCallback) => {
  try {
    const refreshToken = retrieve("refreshToken");

    if (!refreshToken) {
      logoutCallback();
      return;
    }

    const response = await apiClient.post(`${signInUrl}/refresh`, { refreshToken });
    const { accessToken } = response.data;

    const decoded = jwtDecode(accessToken);
    const newExpiry = decoded.exp * 1000;

    store("accessToken", accessToken);
    store("accessTokenExpiry", newExpiry);

    monitorTokenExpiration(logoutCallback);
  } catch (err) {
    logoutCallback();
  }
};

export const monitorTokenExpiration = (logoutCallback = logout) => {
  startUserActivityTracker(logoutCallback);

  const token = retrieve("accessToken");
  const expiry = retrieve("accessTokenExpiry");

  if (!token || !expiry) {
    return;
  }

  const expiryTime = new Date(expiry).getTime();
  const timeUntilExpiryMs = expiryTime - Date.now();
  const timeUntilExpirySec = Math.floor(timeUntilExpiryMs / 1000);

  if (isNaN(expiryTime) || timeUntilExpirySec <= 0) {
    logoutCallback();
    return;
  }

  let refreshTimeSec = Math.floor((timeUntilExpiryMs - 2 * 60 * 1000) / 1000);
  refreshTimeSec = Math.max(refreshTimeSec, 0);

  if (refreshTimeSec === 0) {
    console.log("[HS Auth] Refreshing immediately.");
    RefreshToken(logoutCallback);
    return;
  }

  if (monitorTimeout) clearTimeout(monitorTimeout);

  monitorTimeout = setTimeout(() => {
    const userActive = isUserActive();

    if (userActive) {
      RefreshToken(logoutCallback);
    } else {
      logoutCallback();
    }
  }, refreshTimeSec * 1000);
};